<template>
  <v-card class="pa-0 mx-auto card-box">
    <v-toolbar color="white">
      <h1 class="text-primary pa-0 mx-auto mt-2">
        {{ $t("app_bar.homepage") }}
      </h1>
    </v-toolbar>
    <v-card-text
      class="pa-0 pa-sm-2 pa-md-3 pa-lg-4 pa-xl-4 mt-3 mt-sm-0 mt-sm-0"
    >
      <v-row>
        <v-col cols="12" md="6" class="pb-0 pa-2 pa-sm-2 pa-md-2">
          <v-card class="" color="" elevation="1">
            <v-img
              src="images/landing_1.png"
              style="max-width: 100%"
              cover
              class="mx-auto"
              ><div class="fadebox1"></div>
            </v-img>
            <v-card-text class="linear1">
              <v-row justify="space-around">
                <v-col cols="12" sm="12" md="8" lg="8" xl="8" class="pa-2">
                  <v-btn
                    variant="flat"
                    block
                    color=""
                    rounded="lg"
                    size="75"
                    class="btnlinear1"
                    to="/info_undergraduate"
                    elevation="3"
                    ><p class="p-extra1 text-center">
                      <v-icon class="my-auto"
                        >mdi-information-slab-circle</v-icon
                      >
                      {{ $t("landing.info") }} /<br />{{
                        $t("landing.document")
                      }}
                    </p>
                  </v-btn>
                </v-col>
                <v-col cols="12" sm="12" md="8" lg="8" xl="8" class="pa-2">
                  <v-btn
                    variant="flat"
                    block
                    color=""
                    rounded="lg"
                    size="x-large"
                    class="btnlinear2 mb-3"
                    to="/list_undergraduate"
                    elevation="3"
                    ><p class="p-extra text-center">
                      <v-icon class="my-auto">mdi-list-box</v-icon>
                      {{ $t("landing.list") }}
                    </p>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          md="6"
          class="pa-2 px-sm-2 pb-sm-2 pa-md-2 pt-sm-2 pt-2"
        >
          <v-card class="" color="" elevation="1">
            <v-img
              src="images/landing_2.png"
              style="max-width: 100%"
              cover
              class="mx-auto"
              ><div class="fadebox1"></div>
            </v-img>
            <v-card-text class="linear1">
              <v-row justify="space-around">
                <v-col cols="12" sm="12" md="8" lg="8" xl="8" class="pa-2">
                  <v-btn
                    variant="flat"
                    block
                    color=""
                    rounded="lg"
                    size="75"
                    class="btnlinear1"
                    to="/info_graduate"
                    elevation="3"
                    ><p class="p-extra1 text-center">
                      <v-icon class="my-auto"
                        >mdi-information-slab-circle</v-icon
                      >
                      {{ $t("landing.info") }} /<br />{{
                        $t("landing.document")
                      }}
                    </p>
                  </v-btn>
                </v-col>
                <v-col cols="12" sm="12" md="8" lg="8" xl="8" class="pa-2">
                  <v-btn
                    variant="flat"
                    block
                    color=""
                    rounded="lg"
                    size="x-large"
                    class="btnlinear2 mb-3"
                    to="/list_graduate"
                    elevation="3"
                    ><p class="p-extra text-center">
                      <v-icon class="my-auto">mdi-list-box</v-icon>
                      {{ $t("landing.list") }}
                    </p>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>

  <v-card
    class="card-box mx-auto mt-3"
    :loading="loading"
    :disabled="loading"
    v-if="surrogated_student_info"
  >
    <v-card-text>
      <h2 class="mt-5 text-center">
        <div v-if="uid">
          {{ `เลขที่ใบสมัคร ${surrogated_student_info.APPLY_ID}` }}
        </div>
        <div v-if="student_id">
          {{ `รหัสนักศึกษา ${student_id}` }}
        </div>
      </h2>
      <h2 class="mt-3 text-center">
        {{
          `${surrogated_student_info.STUDENT_FNAME_TH} ${surrogated_student_info.STUDENT_LNAME_TH}`
        }}
      </h2>

      <v-btn
        block
        color="warning"
        elevation="5"
        class="mt-5"
        :to="{ path: 'main' }"
        prepend-icon="mdi-card-account-details-outline"
        v-if="uid"
      >
        {{ $t("app_bar.main") }}
      </v-btn>

      <v-btn
        block
        elevation="0"
        class="mt-5"
        variant="outlined"
        :to="{ path: 'kmitl1' }"
        prepend-icon="mdi-card-account-details-outline"
        v-if="is_completed"
      >
        {{ $t("kmitl1.title") }}
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
// @ is an alias to /src
import UserProvider from "@/services/user.provider.js";

const userProvider = new UserProvider();

export default {
  name: "IndexView",

  data: () => ({
    loading: false,

    validSurrogated: false,
    inputSurrogatedRegisterId: "",
    surrogetedStudentRules: [
      (v) => !!v || "Register ID is required",
      (v) => /^\d+$/.test(v) || "Register ID must be valid",
    ],

    error_message: "",
  }),

  computed: {
    is_authorized_officer() {
      return this.$store.state.user.is_authorized_officer;
    },

    uid() {
      return this.$store.state.user.surrogated_student_uid;
    },

    student_id() {
      return this.$store.state.user.surrogated_student_id;
    },

    surrogated_student_info() {
      return this.$store.state.user.surrogated_student_info;
    },

    is_completed() {
      if (
        this.surrogated_student_info &&
        this.surrogated_student_info.MATRICULATION_STATUS_ID == "3"
      )
        return true;
      else return false;
    },
  },

  methods: {
    async loginSurrogatedStudent() {
      this.loading = true;
      const response = await userProvider
        .getUIDbyRegisterID(this.inputSurrogatedRegisterId)
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
        });
      if (response?.uid) {
        sessionStorage.setItem("surrogated_student_uid", response.uid);
        await this.$store.dispatch("user/getUserInfo");
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.card-title-primary {
  background-color: #f2500b;
  /* background-color: #E35205; */
  /* Other styles for your card title */
}
.card-box {
  max-width: 700px;
}
.p-extra {
  font-family: "Sarabun", sans-serif !important;
  font-weight: 500 !important;
  font-size: 18px !important;
}

.p-extra1 {
  font-family: "Sarabun", sans-serif !important;
  font-weight: 500 !important;
  font-size: 16px !important;
}

@media screen and (max-width: 959px) {
  .card-box {
    max-width: 450px;
  }
}

.linear1 {
  /* background-image: linear-gradient(180deg, #f46303 0%, #ffbe0b 54%, #ffe5bf); */
  background-color: #f46303;
}

.linear2 {
  background-image: linear-gradient(180deg, #93cae5 60%, #3b3939);
}

.btnlinear1 {
  background-color: #ffffff;
  color: rgb(255, 121, 11);
}
.btnlinear2 {
  background-color: hsl(0, 0%, 100%);
  color: rgb(255, 121, 11);
}
.btnlinear3 {
  background-color: #00a1e4;
  color: wheat;
  text-shadow: 0px 0px 4px black;
}
.btnlinear4 {
  background-color: #7d53de;
  color: wheat;
  text-shadow: 0px 0px 4px black;
}

.fadebox1 {
  background-image: linear-gradient(180deg, rgba(0, 0, 0, 0) 70%, #f46303);
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 20%;
}
.fadebox2 {
  background-image: linear-gradient(180deg, rgba(0, 0, 0, 0) 50%, #93cae5);
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 25%;
}
</style>
